export interface HtmlTextValue {
  arabic: string;
  english: string;
}
export enum TermsAndConditionsType {
  TermsAndConditions = '0',
  PrivacyPolicy = '1',
  AboutUs = '2',
  DeliveryInformation = '3',
  Support = '4',
  ContactUs = '5',
}

export interface TermsAndConditionModel {
  type: TermsAndConditionsType;
  value: HtmlTextValue;
}
export interface TermsAndCondition {
  termsAndConditionsDTO: termsAndConditionsDTO;
}

export type termsAndConditionsDTO = { type: TermsAndConditionsType; arabicValue: string; englishValue: string };
